import { AutomationTriggerEvent, ServiceCategory } from '@prisma/client';
import {
  AutomationRecipeDisplay,
  AutomationRecipeId,
} from '../types/marketing/automations';

export const AUTOMATION_TRIGGER_EVENT_LABEL: Record<
  AutomationTriggerEvent,
  string
> = {
  CHECKOUT_COMPLETED: 'Checkout',
  BOOKING_REQUEST_SUBMITTED: 'Booking request',
};

export const AUTOMATION_SERVICE_CATEGORY_LABEL: Record<
  ServiceCategory,
  string
> = {
  PIERCING: 'Piercing',
  TATTOO: 'Tattoo',
  PERMANENT_MAKEUP: 'Permanent makeup',
  SPA: 'Spa',
  OTHER: 'Other',
};

export const AUTOMATION_RECIPE_DISPLAY: Record<
  AutomationRecipeId,
  AutomationRecipeDisplay
> = {
  'healing-check-in': {
    title: 'Healing check-in',
    description:
      'Check in with tattoo clients 2 weeks after checkout and offer a touch-up.',
  },
  'piercing-downsize-reminder': {
    title: 'Piercing downsize reminder',
    description:
      'Remind piercing clients 4 weeks after checkout to book their downsize.',
  },
  'tattoo-rebooking-nudge': {
    title: 'Tattoo rebooking nudge',
    description:
      'Nudge tattoo clients to book their next piece 90 days after checkout.',
  },
  'pmu-perfecting-session': {
    title: 'PMU perfecting session',
    description:
      'Remind permanent makeup clients to book their 6-8 week perfecting session.',
  },
};
